<template>
  <div class="ia4com-page">
    <!--
      A PAGINA SO EXISTE PARA QUEM ESTA NO ROLLOUT.

      O item do menu ja e escondido em MenuSidebar.vue, mas esconder link nao e
      controle de acesso: /assistant digitado na barra de enderecos chegaria aqui
      igual. Enquanto a resposta nao volta a pagina fica vazia — nunca mostramos
      o quadro antes de saber, senao o iframe carregaria o IA4COM para quem nao
      tem direito a ele.
    -->
    <!--
      O ACEITE DOS TERMOS VEM ANTES DO ASSISTENTE (TEL-2272).

      Mesma razao pela qual o rollout e checado antes de montar o quadro: se o
      iframe nascesse agora e o modal so cobrisse por cima, o IA4COM ja teria
      carregado e — pior — o token de sessao ja teria viajado para dentro dele.
      Cobrir com CSS nao e controle de acesso.

      Desde o TEL-2327 essa regra mora em QuadroIA4COM.vue, junto com a ponte:
      o painel lateral do relatorio de chamadas precisa dela igual.
    -->
    <!--
      O CABECALHO E DO PORTAL, E FICA FORA DO CARD — E FORA DA CONDICAO.

      O desenho e o da tela de Relatorios (.report-page-header em
      Report/Calls.vue): icone em quadrado arredondado, titulo, subtitulo, e
      24px ate o que vem embaixo. Ali o titulo diz de que PAGINA se trata e o
      card e a ferramenta; aqui e a mesma divisao — o card comeca onde o
      IA4COM comeca, e nada do portal entra nele.

      Ate aqui a marca aparecia duas vezes na mesma tela: o item do menu dizia
      IA4COM e o painel de conversas dentro do iframe repetia marca, nome e
      "beta" logo ao lado. Duas cascas competindo pela mesma pergunta — onde eu
      estou. Quem hospeda e quem responde isso, entao a marca subiu para ca e
      sumiu de la (`showBrand` do ThreadRail, no ia4com-app).

      So o quadrado do icone foge do padrao do Relatorios, que usa cinza
      (#374151): aqui ele e o ciano da faisca, a mesma cor do item no menu e da
      marca do app la dentro.

      ELE VALE TAMBEM ENQUANTO O ACEITE ESTA PENDENTE. Ja esteve preso ao estado
      dos termos por descuido, e o efeito era uma pagina sem titulo nenhum, com o
      pedido de aceite flutuando num limbo cinza: quem chegava ali nao tinha como
      saber em que tela estava. O cabecalho responde "onde eu estou", e essa
      pergunta existe antes do aceite tambem. Por isso ele so depende do rollout.
    -->
    <!--
      `key` NOS DOIS BLOCOS DE CIMA, e nao e enfeite. Sem ele, quando o rollout
      responde o "Carregando…" sai e o cabecalho entra na MESMA posicao, e o Vue 2
      reaproveita a mesma <div> em vez de trocar. A altura que `ajustarAltura`
      escreveu a mao no bloco de carregamento ficava no cabecalho: ~800px de
      cabecalho flex, o titulo no meio da tela e o quadro empurrado para baixo.
    -->
    <div
      v-if="isAllowed"
      key="cabecalho"
      class="ia4com-page-header">
      <div class="ia4com-page-header__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor">
          <path d="M10 2.5 11.75 7.75 17 9.5 11.75 11.25 10 16.5 8.25 11.25 3 9.5 8.25 7.75Z" />
          <path d="M17.5 13 18.4 15.6 21 16.5 18.4 17.4 17.5 20 16.6 17.4 14 16.5 16.6 15.6Z" />
        </svg>
      </div>
      <div class="ia4com-page-header__text">
        <h1 class="ia4com-page-header__title">
          IA4COM
          <span class="ia4com-beta">Beta</span>
        </h1>
        <p class="ia4com-page-header__subtitle">
          Seu assistente de vendas
        </p>
      </div>
    </div>

    <!--
      A ESPERA ANTES DO QUADRO — a da consulta do rollout.

      A espera dos termos e o veu sobre o iframe moram em QuadroIA4COM.vue desde o
      TEL-2327; aqui sobrou so a do rollout. O desenho e o mesmo dos dois lados,
      porque para quem olha e a MESMA espera: uma tela que ainda nao e a tela.

      UM BLOCO SO PORQUE `ref` NAO SE REPETE. Isto ja esteve em dois
      elementos com o mesmo `ref="corpo"`, e no Vue 2 isso e defeito: quando um
      sai e o outro entra, a baixa da referencia do que saiu apaga a do que
      entrou, e `ajustarAltura` passa a medir um no solto — ou nada.

      Enquanto `isAllowed` e null a frase e MUDA de proposito: ainda nao se sabe
      se esta pessoa pode ver que o IA4COM existe, e e por isso que ate o
      cabecalho espera. Mas "nao dizer o que e" nao obriga a nao dizer "estou
      carregando": a tela ficava branca e inteira, e branco nao e discricao — e
      a pessoa achando que a pagina quebrou.
    -->
    <div
      v-if="esperando"
      key="carregando"
      ref="corpo"
      class="ia4com-carregando ia4com-carregando--pagina">
      <img
        src="/static/images/loading.gif"
        width="28"
        height="28"
        alt=""
        aria-hidden="true" />
      <span>Carregando…</span>
    </div>

    <!--
      O QUADRO E A PONTE SAIRAM PARA QuadroIA4COM.vue (TEL-2327): o painel lateral
      do relatorio de chamadas usa a mesma ponte, e duas copias divergiriam. O
      aceite dos termos, o veu e o handshake moram la; aqui ficam o rollout, o
      cabecalho e a medicao de altura.

      `?callId=` na URL abre a pagina ja com uma ligacao — link direto. O caminho
      do botao do relatorio e o painel, nao esta pagina.
    -->
    <QuadroIA4COM
      v-if="isAllowed"
      ref="quadro"
      :call-id="ligacaoDoLink"
      :pedido-em="pedidoDaRota" />
  </div>
</template>

<script>
/**
 * A pagina do IA4COM dentro do portal.
 *
 * ESTA CASCA E DE PROPOSITO BURRA. O IA4COM inteiro — interface, gateway de
 * modelos, chaves, registro da fase 1 — vive no repositorio ia4com-app e e
 * servido pelo Nitro dele. Aqui so existe o <iframe> e a ponte de identidade.
 *
 * Se um dia aparecer logica de IA neste arquivo, a fronteira vazou: o lugar
 * dela e la. O precedente e o Webphone/Index.vue, que tambem e uma pagina do
 * portal que hospeda algo de fora.
 *
 * A ponte de identidade: o portal ja tem o `loopback-token` do pbxapi no
 * localStorage. Mandamos ele por postMessage; o IA4COM troca por uma sessao
 * propria (cookie httpOnly do lado dele) e nunca guarda o token. Assim o
 * vendedor NAO digita senha de novo — a tela de login do IA4COM existe so para
 * desenvolvimento e para quem abre o app avulso.
 *
 * O protocolo esta documentado dos dois lados. Mexeu aqui, mexa em
 * `app/composables/useEmbed.ts` do ia4com-app:
 *
 *   iframe -> nos    : ia4com:ready      montei, pode mandar
 *   nos    -> iframe : ia4com:identity   quem e a conta, o vendedor e o token
 *   nos    -> iframe : ia4com:ligacao    a ligacao escolhida (TEL-2327)
 *   nos    -> iframe : ia4com:visibilidade  o painel escondeu ou mostrou o quadro
 *
 * A ponte em si mora em QuadroIA4COM.vue desde o TEL-2327.
 */
import { isFeatureAllowed, IA4COM_FEATURE_FLAG } from '../../services/rollout'
import QuadroIA4COM from './QuadroIA4COM.vue'

export default {
  name: 'IA4COM',

  components: { QuadroIA4COM },

  data () {
    return {
      /** null enquanto a checagem de rollout nao respondeu */
      isAllowed: null,

      /**
       * A ligacao do link direto (`/assistant?callId=`), guardada aqui e tirada da
       * URL: com ela na barra, cada F5 ou voltar do navegador abriria outra
       * conversa e outro preparo no IA4COM.
       */
      ligacaoDoLink: null,

      /** muda a cada link consumido, para o quadro reabrir mesmo a mesma ligacao */
      pedidoDaRota: 0,

      /** o .main-content do portal e o `min-height` que ele tinha antes de nos */
      areaDoConteudo: null,
      minHeightAnterior: ''
    }
  },

  computed: {
    /**
     * A tela ainda nao e a tela: falta saber do rollout. Quem nao tem a flag nao
     * passa por aqui — o `created` ja mandou essa pessoa para a home. A espera
     * dos termos mora no quadro.
     */
    esperando () {
      return this.isAllowed === null
    }
  },

  watch: {
    '$route.query.callId' () {
      this.consumirLigacaoDoLink()
    }
  },

  created () {
    this.consumirLigacaoDoLink()
    isFeatureAllowed(IA4COM_FEATURE_FLAG).then(isAllowed => {
      this.isAllowed = isAllowed
      if (!isAllowed) {
        // quem nao tem a flag nao fica numa tela em branco explicando que
        // existe algo que ele nao pode ver: para o portal, esta rota nao existe
        this.$router.replace({ name: 'home' })
        return
      }
      /*
       * REMEDIR AQUI, que o cabecalho acabou de entrar na tela.
       *
       * Ele empurra o corpo uns 70px para baixo. Sem esta linha o bloco de
       * carregamento ficaria com a altura que tinha ANTES do cabecalho, o
       * conteudo passaria da janela e o rodape desceria para fora — o mesmo
       * pulo de antes, so que para o outro lado.
       */
      this.$nextTick(this.ajustarAltura)
    })
  },

  mounted () {
    this.soltarAlturaMinima()
    this.ajustarAltura()
    window.addEventListener('resize', this.ajustarAltura)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.ajustarAltura)
    this.devolverAlturaMinima()
  },

  methods: {
    /**
     * O LINK DIRETO E CONSUMIDO UMA VEZ: guarda a ligacao, pede ao quadro e tira o
     * `callId` da URL. A remocao dispara o watcher de novo, sem `callId`, e ai
     * nao ha nada a fazer — a ligacao ja esta na fila do quadro.
     */
    consumirLigacaoDoLink () {
      const callId = this.$route.query.callId
      if (typeof callId !== 'string' || !callId) return
      this.ligacaoDoLink = callId
      this.pedidoDaRota = Date.now()
      const query = Object.assign({}, this.$route.query)
      delete query.callId
      this.$router.replace({ query })
    },

    /**
     * O ULTIMO PEDACO DE ROLAGEM NAO ERA NOSSO.
     *
     * O .main-content do portal tem `min-height: calc(100vh - 120px)`, escrito
     * para pagina CURTA nao deixar o rodape subir no meio da tela. Somado ao
     * cabecalho fixo (60px) e ao proprio rodape (~62px), esse minimo sozinho ja
     * passa da janela — em pagina de conteudo longo ninguem repara, porque ali a
     * rolagem existe de qualquer forma.
     *
     * Aqui ele e o que sobrava depois de o quadro devolver tudo o que podia: uns
     * poucos pixels, e uma barra de rolagem aparece por um pixel do mesmo jeito
     * que por cem. Nesta pagina o minimo nao tem trabalho para fazer — o quadro
     * preenche a area por construcao —, entao ele fica suspenso enquanto ela
     * vive e volta ao sair.
     *
     * No elemento, e nao no CSS: uma regra global para `.main-content` valeria
     * para o portal inteiro depois que o bundle carregasse esta rota uma vez.
     * Isto aqui comeca e termina com a pagina, e guarda o valor de antes em vez
     * de assumir que era vazio.
     */
    soltarAlturaMinima () {
      const area = this.$el && this.$el.closest && this.$el.closest('.main-content')
      if (!area) return
      this.areaDoConteudo = area
      this.minHeightAnterior = area.style.minHeight
      area.style.minHeight = 'auto'
    },

    devolverAlturaMinima () {
      if (!this.areaDoConteudo) return
      this.areaDoConteudo.style.minHeight = this.minHeightAnterior
      this.areaDoConteudo = null
    },

    /**
     * A altura sai de uma MEDIDA, nao de um numero no CSS.
     *
     * O que fica acima desta pagina varia: cabecalho, faixa de saldo, avisos que
     * aparecem e somem. Um `calc(100vh - 70px)` acerta hoje e erra amanha — foi
     * o que aconteceu: com a faixa de saldo no ar sobravam 90px, o quadro passava
     * 20px da tela e comia o rodape do IA4COM.
     *
     * Medir o proprio topo resolve para qualquer combinacao, inclusive as que
     * ainda nao existem.
     */
    ajustarAltura () {
      // A medida e do QUADRO, nao da pagina: desde que o cabecalho entrou, o
      // topo da pagina e o topo do quadro deixaram de ser o mesmo ponto, e medir
      // a pagina devolveria a altura do cabecalho de brinde — exatamente o
      // excesso que ja comeu o rodape do IA4COM uma vez, so que agora fixo.
      /*
       * O ALVO E "O CORPO DESTA PAGINA", e nem sempre ele e o quadro.
       *
       * Antes do quadro existir o corpo e o bloco de carregamento, e ele
       * precisa da MESMA altura que o quadro vai ter. Sem isto ele media so os
       * seus 320px de piso, o .main-content encolhia junto (o `min-height` do
       * portal esta suspenso enquanto esta pagina vive — ver
       * `soltarAlturaMinima`) e o rodape de copyright subia para o meio da
       * tela. Quando o quadro nascia, ele descia de volta: o rodape dava um
       * pulo a cada abertura da pagina.
       *
       * A ordem importa: o quadro primeiro, porque quando ele existe o bloco de
       * carregamento ja saiu do DOM e o `corpo` seria nulo de qualquer forma —
       * mas deixar explicito evita que alguem inverta sem perceber.
       */
      // o quadro e um componente desde o TEL-2327: mede-se a raiz dele
      const alvo = (this.$refs.quadro && this.$refs.quadro.$el) || this.$refs.corpo
      if (!alvo || !alvo.getBoundingClientRect) return

      const topo = alvo.getBoundingClientRect().top
      const altura = Math.max(320, window.innerHeight - topo)
      alvo.style.height = altura + 'px'

      /*
       * E DEVOLVE O QUE PASSOU.
       *
       * A conta acima leva o quadro ate a ULTIMA linha da janela, e abaixo dele
       * ainda ha coisa do portal: o respiro de 30px do .main-content e o rodape
       * de copyright. O resultado era uma pagina com barra de rolagem para
       * mostrar 90px de nada — e rolar uma tela cujo conteudo ja rola por dentro
       * e o defeito classico de pagina com iframe.
       *
       * O que sobra so da para medir DEPOIS de esticar, porque e o esticao que
       * empurra o rodape para fora. Entao: estica, pergunta ao documento quanto
       * ficou rolavel, e desconta. Vale para o que existe hoje e para o que
       * aparecer depois (uma faixa nova, um aviso) sem ninguem refazer a conta —
       * e nao ha segunda passada: so o alvo tem altura elastica aqui.
       */
      const doc = document.documentElement
      const excesso = doc.scrollHeight - doc.clientHeight
      if (excesso > 0) alvo.style.height = Math.max(320, altura - excesso) + 'px'
    }
  }
}
</script>

<style scoped>
/*
 * O IA4COM tem rolagem propria (a conversa). Duas barras de rolagem aninhadas
 * sao o defeito classico de pagina com iframe, entao a pagina do portal nao
 * rola: o quadro ocupa a altura util e a rolagem acontece dentro dele.
 */
.ia4com-page {
  padding: 0;
  overflow: hidden;
}

/*
 * O SINAL DE CARGA — o mesmo dos Relatorios (loading.gif de 28px + uma frase),
 * porque esperar deve ter a mesma cara em todo o portal.
 *
 * Aqui ele aparece antes de saber do rollout. As outras duas esperas — antes de
 * saber dos termos, e por cima do quadro ate o app avisar que desenhou — moram
 * em QuadroIA4COM.vue, com o mesmo desenho: sao esperas diferentes para quem
 * programa e a MESMA espera para quem olha.
 */
.ia4com-carregando {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #6b7280;
  font-size: 0.875rem;
}

/*
 * Fora do card (rollout e termos) ele e o corpo da pagina. O minimo de 320px e
 * o mesmo piso do quadro (ver `ajustarAltura`): sem ele a pagina encolheria
 * para a altura de uma linha e o rodape do portal subiria para o meio da tela
 * — o `min-height` do .main-content esta suspenso enquanto esta pagina vive.
 */
.ia4com-carregando--pagina {
  min-height: 320px;
}

/* Os valores sao os do .report-page-header (Report/Calls.vue), copiados e nao
   aproximados: dois cabecalhos de pagina que quase combinam leem pior do que dois
   que combinam ou dois que se assumem diferentes. */
.ia4com-page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.ia4com-page-header__icon {
  padding: 0.5rem;
  border-radius: 0.5rem;
  /* o cinza #374151 do Relatorios da lugar ao ciano da marca — e a unica coisa
     desta tela que nao e do portal, e e de proposito */
  background: #36bbef;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ia4com-page-header__icon svg {
  width: 20px;
  height: 20px;
  display: block;
}
.ia4com-page-header__title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.2;
  margin: 0;
}
.ia4com-page-header__subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.4;
  margin: 4px 0 0 0;
}

/* Mesmo desenho do `.badge.new` do menu, do lado claro: e a mesma informacao
   (isto e beta) e ler diferente em duas telas seguidas parece outro produto. */
.ia4com-beta {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 8px;
  background-color: #007bff;
  color: #fff;
  vertical-align: middle;
  margin-left: 6px;
}

</style>



// WEBPACK FOOTER //
// src/components/IA4COM/Index.vue